import { ajaxAuth } from '../gateway'
import { attemptActionWithToast, askQuestion } from '@/services/prompts'

/**
 * List all exclusion policies
 */
export function listExclusionPolicies () {
  return ajaxAuth.get('/exclusion-policies')
}

export function removeExclusionPolicy (id) {
  return ajaxAuth.delete(`/exclusion-policies/${encodeURIComponent(id)}`)
}

/**
 * Create a new exclusion policy
 */
export function createNewExclusionPolicy (policy) {
  return ajaxAuth.post('/exclusion-policies', policy)
}

export async function procedureNewExclusionPolicy (vm, n, selectedMetaData) {

  // get a name / comment
  const comments = await askQuestion(
    vm,
    'Describe this exclusion policy',
    'e.g., Android bug causes false positives',
    'is-danger')
  if (!comments) return false

  // create a policy
  const policy = {
    comments,
    scope: {},
    metaData: selectedMetaData
      .filter(property => property !== 'groups')
      .map(property => ({ property, match: n.metaData[property] })),
  }

  return await attemptActionWithToast(
    vm,
    async () => await createNewExclusionPolicy(policy),
    () => {},
    'Policy created',
    e => `Unable to created, ${e.message}`
  )
}
